import React from 'react';
import useBookmarks from '../../hooks/useBookmarks';
import NewsItem from '../news/NewsItem';

/**
 * Bookmarks page displaying saved articles.
 * Shows an illustrative empty state when no articles are saved.
 */
const Bookmarks = () => {
  const { bookmarks, isBookmarked, toggleBookmark } = useBookmarks();

  return (
    <div className="container py-4">
      <div className="text-center mb-4">
        <span className="qs-eyebrow">Your Collection</span>
        <h1 className="qs-page-title">Bookmarks</h1>
      </div>

      {bookmarks.length === 0 ? (
        <div className="text-center py-5">
          <svg className="mb-3" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.3">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
          </svg>
          <h4 className="qs-muted mb-2">No bookmarks yet</h4>
          <p className="qs-muted" style={{ opacity: 0.6 }}>
            Click the bookmark icon on any article to save it here
          </p>
        </div>
      ) : (
        <>
          <p className="qs-muted mb-4">{bookmarks.length} saved article{bookmarks.length !== 1 ? 's' : ''}</p>
          <div className="row g-4">
            {bookmarks.map((article, index) => (
              <div className="col-12 col-sm-6 col-md-4" key={`bookmark-${article.url}-${index}`}>
                <NewsItem
                  title={article.title}
                  description={article.description}
                  imageUrl={article.image}
                  newsUrl={article.url}
                  author={article.author}
                  date={article.date}
                  source={article.source}
                  article={article}
                  isBookmarked={isBookmarked(article.url)}
                  onToggleBookmark={toggleBookmark}
                />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

Bookmarks.displayName = 'Bookmarks';

export default Bookmarks;
